<nav>
  <div class="main-flex">
    <div class="right-flex">
      <div class="club">
        <div class="image background-loading-tiny">
          <img [src]="logoUrl" alt="" appDefaultImage />
        </div>
        <p class="title">{{ clubName }}</p>
        <div class="change">
          <!--            <app-icon [planIcon]="true" color="#D8D8D8" iconName="chevron-up-down" size="16px"></app-icon>-->
        </div>
      </div>
      <div class="search">
        <div class="container">
          <input (keyup.enter)="search($event)" [(ngModel)]="searchInput" [placeholder]="'header.start typing' | translate" class="input" type="text" />
          <div class="icon">
            <app-icon [planeIcon]="true" color="var(--slate-gray)" iconName="search" size="20px"></app-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="left-flex">
      <!--      <div-->
      <!--        class="messages cursor-pointer"-->
      <!--        [tippy]="messages"-->
      <!--        [data]="{ name: username }"-->
      <!--        className="popper-menu"-->
      <!--        variation="popper"-->
      <!--      >-->
      <!--        <app-icon [planeIcon]="true" color="var(&#45;&#45;slate-gray)" iconName="message" size="20px"></app-icon>-->
      <!--        <p *ngIf="showLabel()" class="label" translate>header.messages</p>-->
      <!--        <div class="badge">-->
      <!--          <app-icon [planeIcon]="true" iconName="notification-badge" size="10px"></app-icon>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="notifications" (click)="openNotificationDialogBox()">-->
      <div [data]="{ name: username }" [maxWidth]="'480px'" [placement]="'bottom-end'" [tippy]="notifications" class="notifications" className="popper-menu" placement="bottom" variation="popper">
        <app-icon [planeIcon]="true" color="var(--slate-gray)" iconName="notification" size="20px"></app-icon>
        @if (showLabel()) {
          <p class="label" translate>Notifications</p>
        }
        @if (hasNotifications) {
          <div class="badge">
            <app-icon [planeIcon]="true" iconName="notification-badge" size="10px"></app-icon>
          </div>
        }
      </div>
      <div class="language">
        <!--        <app-icon [cssStyle]="{ 'margin-top': '2px' }" [planeIcon]="true" color="var(&#45;&#45;slate-gray)" iconName="globe" size="20px"></app-icon>-->
        <img alt="-" class="lang-flag-icon" src="assets/lang-flags/{{ selectedLanguage.toLowerCase() }}.png" />
        <app-language-selector (selectedLanguage)="selectedLanguage = $event" [inNavbar]="true"></app-language-selector>
      </div>

      <div class="user cursor-pointer">
        <div (click)="openProfileImageUpdateDialog($event)" class="image background-loading-small">
          @if (showProfileImage) {
            <img [appFetchProfileImage]="memberId" [fetchFromLocal]="fetchFromLocal" alt="" src="assets/images/placeholder.png" />
          }
        </div>
        <div [tippy]="menu" class="flex-row-between-center gap-10" className="popper-menu" variation="popper">
          <div>
            <p class="username">{{ fullName }}</p>
            <p class="role">{{ userRole | humanize | translate }}</p>
          </div>
          <app-icon [cssStyle]="{ marginBottom: '-4px' }" iconName="chevron-down"></app-icon>
        </div>
      </div>
    </div>
  </div>
</nav>

<!-- User popover menu -->
<ng-template #menu let-hide>
  <!-- This menu-content is generic class can be override with custom style as well, adjust width value directly as per need -->
  <div class="popper-menu-content" style="width: 150px">
    <ul>
      <li (click)="hide()" routerLink="/user/my-profile">
        <label translate>nav.profile</label>
      </li>
      <li (click)="hide()" routerLink="/logout">
        <label translate>Logout</label>
      </li>
      <li>
        <app-theme-switch></app-theme-switch>
      </li>
    </ul>
  </div>
</ng-template>

<!-- Messages popover -->
<ng-template #notifications let-data="data" let-hide>
  <div class="notifications-popover-content">
    <app-notifications (closePopover)="hide()"></app-notifications>
  </div>
</ng-template>
